import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/core/hy/client.ts
var fetchClient2 = (_0) => __async(void 0, [_0], function* ({ url, options, raw }) {
  var _a;
  const hyConfig = (_a = ApiConfig.config) == null ? void 0 : _a.hy;
  if (!hyConfig) {
    const msg = "HY `ApiConfig` was not initialized. See instructions in https://github.com/nadude/webook-frontend/blob/main/packages/api/README.md";
    throw new Error(msg);
  }
  return fetchClient({
    baseUrl: hyConfig.api,
    url,
    raw,
    options: __spreadProps(__spreadValues({}, options), {
      headers: __spreadProps(__spreadValues({}, options == null ? void 0 : options.headers), {
        token: hyConfig.apiToken
      })
    })
  });
});

export {
  fetchClient2 as fetchClient
};
//# sourceMappingURL=chunk-SKVXOXWB.mjs.map